import { syncWebData } from "credlibkit";

const CLIENT_ID = process.env.REACT_APP_CRED_CLIENT_ID;
const SECRET_KEY = process.env.REACT_APP_CRED_SECRET_KEY;

export const fetchCredeauData = async (userId) => {
  try {
    const result = await syncWebData(`${userId}`, CLIENT_ID, SECRET_KEY);

    if (result) {
      // Data collection successful
      console.log("Sync successful:", result);
    } else {
      // Data collection failed
      console.log("Sync failed");
    }
  } catch (error) {
    // Handle errors
    console.error("SDK Error:", error);
  }
};
